import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { FactTypes } from './DataCollectionSet'
import messages from './messages'

const StyledFieldItem = styled.li`
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  margin: 8px 0;
  padding: 5px 10px;

  &.remove {
    background-color: #f7fafc;
  }
`

const StyledFieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`

const StyledFieldName = styled.p`
  && {
    font-size: 0.75rem;
    margin: 0;
    text-align: left;
    padding-right: 10px;
    font-weight: bold;
    color: #4b4b4b;
  }
`

const StyledFieldButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  margin-left: auto;
  cursor: pointer;
  &:hover {
    background-color: #f9f9f9;
  }
`

const StyledFieldButtonText = styled.p`
  font-size: 0.7rem;
  margin: 0 5px;
  color: #707070;
`

interface DataCollectionFieldRowProps {
  field: FactTypes
  isInDataSetCollection: boolean
  updateCollectionSet: (field: FactTypes) => void
  readOnly?: boolean
}

const DataCollectionFieldRow = ({
  field,
  isInDataSetCollection,
  updateCollectionSet,
  readOnly = false
}: DataCollectionFieldRowProps) => {
  return (
    field.value &&
    field.title && (
      <StyledFieldItem className={isInDataSetCollection ? 'remove' : 'add'}>
        <StyledFieldBlock>
          <StyledFieldName>{field.title}</StyledFieldName>
        </StyledFieldBlock>
        {!readOnly && (
          <StyledFieldButton onClick={() => updateCollectionSet(field)}>
            <StyledFieldButtonText>
              {isInDataSetCollection ? (
                <FormattedMessage {...messages.dataCollectionRemove} />
              ) : (
                <FormattedMessage {...messages.dataCollectionAdd} />
              )}
            </StyledFieldButtonText>
          </StyledFieldButton>
        )}
      </StyledFieldItem>
    )
  )
}

export default DataCollectionFieldRow
